function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}

class McpCartUpsell extends HTMLElement {
    constructor() {
        super();
        this.cart = document.querySelector("cart-drawer");
        this.cartItems = [];
        this.upsell = {
            productsPrice: 0,
            freeDelivery: {},
            freeProduct: {},
        };
    }

    connectedCallback() {
        if (!document.querySelector('#mcp_upsell[type="application/json"]')) return;
        this.getProductsPrice();
    }

    async getProductsPrice() {
        await this.getCartDatas();
        console.log("this.upsell.productsPrice", this.upsell.productsPrice);
        if (Object.keys(this.getCartDatas()).length < 1) return;
        this.cartItems = this.getCartDatas().cart;
        let upsellItems = this.getCartDatas().upsells;
        /* Calculate total price for products requiring shipping */
        console.log("this.cartItems", this.cartItems);
        this.cartItems.map((item) => {
            //if (!item.requires_shipping) return;
            this.upsell.productsPrice =
                this.upsell.productsPrice + item.final_line_price;
        });
        /* Get upsell data */
        upsellItems.map((data) => {
            data.upsell_id === 0
                ? (this.upsell.freeDelivery = data)
                : (this.upsell.freeProduct = data);
        });

        if (Object.keys(this.upsell.freeProduct).length > 0) {
            let upsellId = this.upsell.freeProduct.upsell_id;
            let isInCart = this.verifyCart(upsellId);
            if (this.upsell.productsPrice > this.upsell.freeProduct.value) {
                if (isInCart || !this.upsell.freeProduct.upsell_available) return;
                this.addToCart(upsellId);
            } else {
                if (!isInCart) return;
                // Unable if no discount code
                //this.removeFromCart(upsellId);
            }
        }
    }

    verifyCart(upsellId) {
        console.log("upsellId", upsellId);
        console.log("this.upsell.freeProduct", this.upsell.freeProduct);
        let upsellInCart = this.cartItems.filter((item) => item.id === upsellId);
        if (upsellInCart.length > 0) {
            console.log("UPSELL IN CART");
            return true;
        } else {
            console.log("NONE");
            return false;
        }
    }

    getCartDatas() {
        let upsellData = JSON.parse(
            document.querySelector('#mcp_upsell[type="application/json"]').textContent
        );
        console.log("upsellData", upsellData);
        return upsellData;
    }

    addToCart(productId) {
        console.log("ADD TO CART", productId);
        const body = JSON.stringify({
            id: productId,
            quantity: 1,
        });
        fetch(`${Shopify.routes.root}cart/add.js`, {
            ...fetchConfig(),
            ...{ body },
        })
            .then((response) => {
                return response.json();
            })
            .then((cart) => {
                console.log("CART", cart);
                this.updateCartDrawer(cart);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    removeFromCart(productId, quantity = 0) {
        console.log("REMOVE", productId);
        const body = JSON.stringify({
            id: `${productId}`,
            quantity: `${quantity}`,
        });

        fetch(`${Shopify.routes.root}cart/change.js`, {
            ...fetchConfig(),
            ...{ body },
        })
            .then((response) => {
                return response.json();
            })
            .then((cart) => {
                this.updateCartDrawer(cart);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    updateCartDrawer(cart) {
        //console.log('NEW_CART', cart)
        //console.log('PUB_SUB_EVENTS', PUB_SUB_EVENTS)

        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-drawer",
            cartData: cart,
        });
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
}
customElements.define("mcp-cart-upsell", McpCartUpsell);
